import { makeAutoObservable, runInAction } from "mobx";
import { initSocket, getSocket } from "./socket";
import { showAlertToast } from "../../../../Components/ToastComponent/AlertMessage";
import { MdOutlineDoNotDisturbOnTotalSilence } from "react-icons/md";
class SocketStore {
  messages = [];
  sockets = new Map(); // "company" | "people" → socket instance
  socketInitialized = {
    company: false,
    people: false,
  };
  socketTableIds = {};
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  formateData = ({ msg, type }) => {
    const currentTableId = this.rootStore.gridStore.tableId;
    let data = null;
    if (currentTableId === msg.tableId) {
      data = msg.data;
    }
    // if (type === 'row:bulkAdd') {
    //   this.rootStore.searchId === msg.searchId{
    //     return
    //   }
    // }
    // if (type === 'row:bulkAdd') {
    //   this.rootStore.searchId === msg.searchId{
    //     return
    //   }
    // }
    return data;
  }
  disconnect = async (type) => {
    const socket = this.sockets.get(type);
    if (socket) {
      socket.disconnect();
      runInAction(() => {
        this.sockets.delete(type);
        this.socketInitialized[type] = false;
        delete this.socketTableIds[type];
      });
    }
  };
  initializeSocket = (type, tableId) => {
    let socket = this.sockets.get(type);
    const existingTableId = this.socketTableIds?.[type];
    console.log(this.socketTableIds, this.socketTableIds?.[type], socket, socket && existingTableId !== tableId, "existingTableId");

    // Replace socket if tableId is different
    if (socket && existingTableId !== tableId) {
      socket.disconnect();
      this.sockets.delete(type);
      this.socketInitialized[type] = false;
      socket = null; // clear old socket
    }
    // Initialize if not already present
    if (!this.sockets.get(type) && !this.socketInitialized[type]) {
      socket = initSocket(tableId);
      this.sockets.set(type, socket);
      this.socketInitialized[type] = true;
      this.socketTableIds[type] = tableId;
    }
    // At this point, socket should be set
    socket = this.sockets.get(type);
    if (!socket) return;
    socket.on("connect", () => {
      runInAction(() => {
        this.socketInitialized[type] = true;
      });
    });
    socket.on("disconnect", () => {
      runInAction(() => {
        this.socketInitialized[type] = false;
        this.sockets.delete(type);
      });
    });
    socket.on("newMessage", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.messages.push(msg);
      });
    });
    socket.on("add:column", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.addColumn(msg);
      });
    });
    socket.on("row:update", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      Object.entries(msg.data).forEach(([columnId, value]) => {
        runInAction(() => {
          this.rootStore.gridStore.setCellInRow(msg.rowId, columnId, value);
        });
      });
    });
    socket.on("column:peopleIcon", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        let row = this.rootStore.gridStore.rows.get(msg.rowId);
        let cell = row.cells.get(msg.columnName);
        cell.setEnrichIcon(msg.peopleEnrcih);
      });
    });
    // socket.on("table:notification", (msg) => {
    //   runInAction(() => {
    //   });
    // });
    socket.on("table:loader", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      console.log(msg.loadering, "table:loader");
      if(msg.loadering) {
        runInAction(() => {
          this.rootStore.applyTheValue({
            tableLoader: msg.loadering,
          });
        });
      } else {
        setTimeout(() => {
          runInAction(() => {
            this.rootStore.applyTheValue({
              tableLoader: msg.loadering,
            });
          });
        }, 1000);
      }
    });
    socket.on("table:totalMatch", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.totalRecode = msg.matchedRecords;
      });
    });
    socket.on("row:bulkDelete", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      msg.rowIds.forEach((id) => {
        this.rootStore.gridStore.deleteRow(id);
      });
    });
    socket.on("column:rename", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.renameColumn(msg);
      });
    });
    socket.on("row:delete", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.deleteRow(msg.rowId);
      });
    });
    socket.on("column:delete", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.deleteColumn(msg.columnName);
      });
    });
    socket.on("table:refresh", (data) => {
      // let msg = this.formateData({ msg: data, type: "" });
      // if (!msg) {
      //   return;
      // }
      runInAction(() => {
        if (!this.rootStore.tableReset &&
          (this.rootStore.tableCompanyId !== null || this.rootStore.tablePeopleId !== null)) {
          this.rootStore.resetAllActivefun(true);
        }
      });
    });
    socket.on("table:rename", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.setTableTitle(msg.tableName);
      });
    });
    socket.on("row:add", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.addRow(msg);
        // this.rootStore.gridStore.totalpageRecords();
      });
    });
    socket.on("column:orderChange", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.reorderColumns("socket", msg);
      });
    });
    socket.on("table:rename", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.setTableTitle(msg.tableName);
      });
    });
    socket.on("cell:edit", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.setEditablecell(msg.editCell);
      });
    });
    socket.on("filter:customOption", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.getSelectStore(msg.key);
        this.allowcustomOptions = msg.value;
      });
    });
    socket.on("table:import", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      let importUniqueId = this.rootStore.dynamicFlags.get("importUniqueId");
      if (importUniqueId === (msg?.importUniqueId ?? "")) {
        runInAction(() => {
          this.rootStore.applyTheValue({
            progressMovedRecords: msg.movedRecords,
            progresstotalRecords: msg.totalRecords,
          });
        });
      }
    });
    socket.on("table:permission", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      const rootStore = this.rootStore;
      setTimeout(() => {
        runInAction(() => {
          rootStore.commonRootStoreMap.set("permission", msg);
        });
      }, 2000);
    });
    // this.socket.on("column:limit", (msg) => {
    //   runInAction(() => {
    //     this.rootStore.gridStore.assignColumnLimit(msg.limit);
    //   });
    // });
    socket.on("column:href", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        // this.rootStore.gridStore.assignColumnHrefList(msg);
        // this.rootStore.gridStore.hidecolumn(msg.hrefList)
      });
    });
    socket.on("table:clearAll", (msg) => {
      runInAction(() => {
        this.rootStore.gridStore.columns.clear();
        this.rootStore.gridStore.rows.clear();
      });
    });
    socket.on("table:hiddenColumns", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.hidecolumn(msg.hiddenColumns)
      });
    });
    socket.on("column:aliasFields", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.setaliesColumns(msg.aliasFields);
      });
    });
    socket.on("table:enrich", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.setEnrichementVisible(msg.enrich);
      });
    });
    socket.on("row:bulkAdd", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.addRows(msg);
        this.rootStore.gridStore.totalpageRecords();
      });
    });
    socket.on("dropdown:helpme", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        if (this.rootStore.multiStore.has(msg.keyName)) {
          let store = this.rootStore.multiStore.get(msg.keyName);
          store.setAssignedValues(msg.values);
        }
        if (this.rootStore.multiTextStore.has("jobtitle")) {
          let store = this.rootStore.multiTextStore.get(msg.keyName);
          store.setAssignedValues(msg.values);
        }
      });
    });
    socket.on("table:notification", (data) => {
      console.log(data, "table:notification");

      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      if (msg.title === "Credit Debit") {
        this.rootStore.getuserdetails()
      }
      showAlertToast({
        type: msg.type,
        title: msg.title,
        message: msg.message,
      });
    });
    socket.on("column:convertNumber", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.gridStore.convertColumns.add(msg);
      });
    });
    socket.on("column:normalization", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        if (Array.isArray(msg)) {
          msg.forEach(columnName => {
            if (columnName) {
              this.rootStore.gridStore.formalizeColumns.add(columnName);
            }
          });
        }
      });
    });
    socket.on("enrich:done", (msg) => {
      // const {enrich}=msg;
      // 
    });
    socket.on("table:nlpSavedSearch", (msg) => {
      console.log(msg,"Got in msg for table:nlpSavedSearch")
      this.rootStore.nlpSavedSearch(msg);
    });
    socket.on("dropDown:refill", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.hierarchyUpdate(msg);
      });
    });
    socket.on("dropDown:fill", (data) => {
      let msg = this.formateData({ msg: data, type: "" });
      if (!msg) {
        return;
      }
      runInAction(() => {
        this.rootStore.hierarchyUpdateAI(msg);
      });
    });
    return socket;
  };
  sendMessage = (type, msg) => {
    const socket = this.sockets.get(type);
    if (socket && this.socketInitialized[type]) {
      socket.emit("sendMessage", msg);
    }
  };
}
export default SocketStore;
